// src/CombinedChart.js

import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, PointElement, Title, Tooltip, Legend, BarElement, LinearScale, LineElement } from 'chart.js';
import 'chartjs-plugin-datalabels'; // Import if using datalabels plugin
import GetFormattedDateTime from '../utilities/getFormattedDateTime'; // Ensure this utility is implemented

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement
);

const CombinedChart = (props) => {
  // Extract and transform data from props
  const data = props.data || [];
  const labels = data.map(item => GetFormattedDateTime(item.RequestDate));
  const promotersData = data.map(item => item.PromotersCount);
  const passivesData = data.map(item => item.PassivesCount);
  const detractorsData = data.map(item => item.DetractorsCount);
  const npsData = data.map(item => item.Nps);

  // Create datasets using the transformed data
  const combineDataset = {
    labels: labels,
    datasets: [
      {
        label: 'NPS',
        type: 'line',
        data: npsData,
        fill: false,
        borderColor: '#333333',
        backgroundColor: '#333',
        tension: 0.1,
        borderWidth: 2,
        yAxisID: 'y-axis-2',
      },
      {
        type: 'bar',
        label: 'Promoters',
        data: promotersData,
        backgroundColor: '#008000',
        borderWidth: 0,
        stack: 'stack1',
      },
      {
        type: 'bar',
        label: 'Passives',
        data: passivesData,
        backgroundColor: '#ffb62f',
        borderWidth: 0,
        stack: 'stack1',
      },
      {
        type: 'bar',
        label: 'Detractor',
        data: detractorsData,
        backgroundColor: '#f10000',
        borderWidth: 0,
        stack: 'stack1',
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false, // Assuming you want to hide data labels; adjust as needed
      },
      title: {
        display: false,
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          padding: (0, 15, 0, 10),
          boxWidth: 7,
          boxHeight: 7,
          usePointStyle: true,
        },
        title: {
          display: true,
          padding: -7,
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    layout: {
      padding: {
        bottom: 0,
      },
    },
    scales: {
      x: {
        padding: 0,
        grid: {
          display: false,
        },
        title: {
          display: false,
          text: 'Month',
        },
        ticks: {
          beginAtZero: true,
          padding: 0,
          display: true,
        },
        stacked: true,
        beginAtZero: true,
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          suggestedMax:50,
            suggestedMin:1,
            beginAtZero:true,
            max:100,
            autoSkip:true,
            lineHeight:2,
          beginAtZero: true,
          max: 100,
          callback: function (value) {
            return (value); 
          },
        },
        stacked: true,
        title: {
          display: true,
          text: 'Response Count',
        },
      },
      'y-axis-2': {
        grid: {
          display: false,
        },
        // min: -100,
        // max: 100,
        type: 'linear',
        position: 'right',
        title: {
          display: true,
          text: 'NPS',
        },
        beginAtZero: true,
        stacked: false,
      },
      //--- min: 0 ,
    },
  };

  return (
    <div style={{ height: '178px' }}>
      <Bar data={combineDataset} options={options} />
    </div>
  );
};

export default CombinedChart;
